'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Sortable = require('sortablejs/Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageController = function () {
  function PageController(ProductPagesDataProvider, $state, $document, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, PageController);
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    this.type = 3;
    this.field = 'category_id,sub_category,order_by';
    this.order_type = 'asc';
    this.col = 0;
    this.colTopDown = 0;
    this.$document = $document;
    this.categoryId = $state.params.categoryId;
    this.subCategoryId = $state.params.subCategoryId;
    if (this.categoryId != undefined && this.subCategoryId != undefined) {
      this.pageLimit = '9999';
      var el = document.getElementById('items');
      var vm = this;
      vm.sortingLog = [];
      var sortable = _Sortable2.default.create(el, {
        onStart: function onStart(evt) {
          evt.oldIndex;
          console.log('start');
        },
        onEnd: function onEnd(evt) {
          var oldData = angular.copy(vm.productPages);
          var i = 0;
          if (evt.oldIndex < evt.newIndex) {
            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
              if (i == evt.newIndex) {
                vm.productPages[i] = oldData[evt.oldIndex];
              } else {
                vm.productPages[i] = oldData[i + 1];
              }
            }
          }
          if (evt.oldIndex > evt.newIndex) {
            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
              if (i == evt.newIndex) {
                vm.productPages[i] = oldData[evt.oldIndex];
              } else {
                vm.productPages[i] = oldData[i - 1];
              }
            }
          }
          vm.productPages.map(function (i) {
            vm.sortingLog.push(i.id);
          });
          ProductPagesDataProvider.updateProductPageOrder(vm.sortingLog).then(function (result) {
            vm.getProductPage();
          });
          vm.sortingLog = [];
        }
      });
    }
    this.getProductPage();
  }

  (0, _createClass3.default)(PageController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getProductPage();
    }
  }, {
    key: 'getProductPage',
    value: function getProductPage() {
      var vm = this;
      var data = [];
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.field = vm.field;
      data.order_type = vm.order_type;
      data.categoryId = 0;
      if (vm.categoryId != undefined) {
        data.categoryId = vm.categoryId;
      }
      data.subCategoryId = 0;
      if (vm.subCategoryId != undefined) {
        data.subCategoryId = vm.subCategoryId;
      }
      vm.ProductPagesDataProvider.getProductPages(data, vm.type).then(function (result) {
        vm.productPages = result.data;
        vm.productPagesTotal = result.total;
      });
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(status, id) {
      var vm = this;
      var data = { 'status': status, 'id': id };
      vm.ProductPagesDataProvider.updateProductPageStatus(data).then(function (resp) {
        vm.pages = resp;
        vm.getProductPage();
      });
    }
  }, {
    key: 'removeProductPage',
    value: function removeProductPage(id) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      var vm = this;
      vm.ProductPagesDataProvider.removeProductPage(id).then(function (res) {
        vm.getProductPage();
      });
    }
  }]);
  return PageController;
}();

// WEBPACK FOOTER //


exports.default = PageController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/components/listing/controller.js
 **/